<div id="deliveryAddress" class="subBlockContainer">
  <child-header [title]="title" (closeEvent)="close()" [showAdd]="true" titleAdd="New Address" (addEvent)="newAddress()"></child-header>
  <div class="subBlockContent">
    <div class="panel-content">
      <div class="page-title-wrapper">
        <!-- <div class="title blade-title-font">
          {{title}}
          <div id="buttonNew" class="basic-icon add-icon" (click)="newAddress()"></div>
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
        <p class="page-title-description">
          Save your most commonly used delivery locations here so next time you go through the check-out
          process you don't have to manually enter the delivery location information.
        </p>
        <div class="row filter-wrapper">
          <div class="col-md-12">
            <div class="searchInputGroup searchInputGroup-large">
              <div class="searchIcon">
                <img src="../images/new_ui/filter.png">
              </div>
              <input class="searchInput" type="text" placeholder="Filter"
                onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="filterInput"
                (ngModelChange)="onChange()">
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="hasEmptyFilterResult">
        <div class="noResult-wrapper">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/no-deliveryLoc.png"></div>
          <div id="reason">We couldn't find any saved addresses for your account.</div>
          <button class="button button-red button-large" (click)="newAddress()">Create now</button>
        </div>
      </ng-container>
      <ng-container *ngIf="!hasEmptyFilterResult">
        <div class="top-divider"></div>
        <div class="child-body">
          <div class="shared-outer-wrapper"
            *ngFor="let address of deliveryAddressList | TableFilterMultiple: [ 'companyName' ]: filterInput;let i = index">
            <section *ngIf="address?.addressLine1 !==''">
              <div class="basic-icon edit-icon"(click)="gotoEditMood(address)"></div>
              <div class="company-name-wrapper">{{address?.companyName}}</div>
              <div class="details">{{address?.combinedAddress}}</div>
              <div class="details"><label>ATTN/REF</label>: {{address?.attnOrRef}}</div>
              <div class="details"><label>PHONE</label>: {{address?.phone}}</div>
            </section>
          </div>
        </div>
      </ng-container>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showBlurTable]="false"></loading-screen>

  </div>
</div>

<router-outlet></router-outlet>